import { render, staticRenderFns } from "./PostAssignmentPrototype.vue?vue&type=template&id=2931f9f9&scoped=true&"
import script from "./PostAssignmentPrototype.vue?vue&type=script&lang=js&"
export * from "./PostAssignmentPrototype.vue?vue&type=script&lang=js&"
import style0 from "./PostAssignmentPrototype.vue?vue&type=style&index=0&id=2931f9f9&prod&lang=css&"
import style1 from "./PostAssignmentPrototype.vue?vue&type=style&index=1&id=2931f9f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2931f9f9",
  null
  
)

export default component.exports